import { Box, Heading, HStack, Text, VStack } from "@chakra-ui/react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReactComponent as Shield } from "../../../assets/icons/shieldIcon.svg";
import { ReactComponent as Logo } from "../../../assets/icons/logo_small.svg";
import { StyledButton } from "../../../components";
import { useState } from "react";
import styles from "../styles";

export const SubscriptionsCarousel = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const settings = {
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: true,
        arrows : false,
        centerPadding: "0px",
        slidesToShow: 3,
        beforeChange: (_, next) => setCurrentSlide(next),
        responsive: [
            { breakpoint: 1300, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
    };

    const data = [
        { price: "$197", olfPrice: "$250" },
        { price: "$100", olfPrice: "" },
        { price: "$100", olfPrice: "" },
        { price: "$100", olfPrice: "" },
        { price: "$100", olfPrice: "" },
        { price: "$100", olfPrice: "" },
        { price: "$100", olfPrice: "" },
    ];

    return (
        <Box css={styles.carouselSubs} position="relative" maxW="xl" mt="48px" maxH="780px" mb="24px">
            <Slider  {...settings}>
                {data.map((item, index) => (
                    <Box
                        className={'child'}
                        key={index}
                        bg={'neutral.1100'}
                        boxShadow="0px 4px 4px 0px #00000040"
                        p={'24px 24px 16px 24px'}
                        border="1px solid #6F41D240"
                        borderRadius="24px"
                        maxW="395px"
                        h="full"
                        minH={{ base: "196px", md: "498px", lg: "630px" }}
                        cursor="pointer"
                        transition="all 0.3s ease-in-out"
                        opacity={currentSlide === index ? "1" : "0.5"}
                        transform={currentSlide === index ? "scale(1.2)" : "scale(0.9)"}
                        zIndex={currentSlide === index ? "10" : "1"}
                    >
                        <VStack>
                            <Logo width="118px" height="98px" />
                        </VStack>
                        <HStack justifyContent="center" alignItems="center">
                            <Text fontSize="display.sm" color="neutral.500">
                                <del>{item.olfPrice}</del>
                            </Text>
                            <Heading
                                textAlign="center"
                                color={item.olfPrice ? "unset" : "neutral.500"}
                                bgGradient={
                                    item.olfPrice
                                        ? "linear(to-r, #E59CFF 0.01%, #BA9CFF 50.01%, #9CB2FF 100%)"
                                        : "unset"
                                }
                                bgClip={item.olfPrice ? "text" : "unset"}
                                fontSize={index === currentSlide ? "display.xl" : "display.md"}
                            >
                                {item.price}
                            </Heading>
                        </HStack>
                        <Text textAlign="center" fontSize={index === currentSlide ? "heading.2xl" : "heading.3xl"}>
                            for two months
                        </Text>
                        <VStack fontSize="body.lg" textAlign="start" mt="24px" gap={index === currentSlide ? "32px" : "24px"}>
                            {Array(4)
                                .fill(0)
                                .map((_, i) => (
                                    <HStack key={i}>
                                        <Box>
                                            <Shield />
                                        </Box>
                                        <Text fontSize={'18px'}>Full access to the CEX Scanner with real-time updates and Telegram notifications.</Text>
                                    </HStack>
                                ))}
                            <StyledButton disabled={index !== currentSlide} bg="neutral.1000" w="full">
                                Get Started
                            </StyledButton>
                        </VStack>
                    </Box>
                ))}
            </Slider>
        </Box>
    );
};
